import { makeAutoObservable } from 'mobx';

export enum UNITS_SYSTEM {
	METRIC = 'metric',
	IMPERIAL = 'imperial',
}

export interface IUnitsStore {
	unitsSystem: UNITS_SYSTEM;
	isMetrics: boolean;
	setUnitsSystem: (unitsSystem: UNITS_SYSTEM) => void;
}

export class UnitsStore implements IUnitsStore {
	unitsSystem: UNITS_SYSTEM;

	constructor(locale: string) {
		const region = getRegionFromLocale(locale);
		this.unitsSystem =
			region && isRegionImperial(region) ? UNITS_SYSTEM.IMPERIAL : UNITS_SYSTEM.METRIC;
		makeAutoObservable(this);
	}

	setUnitsSystem = (unitsSystem: UNITS_SYSTEM): void => {
		this.unitsSystem = unitsSystem;
	};

	get isMetrics(): boolean {
		return this.unitsSystem === UNITS_SYSTEM.METRIC;
	}
}

const getRegionFromLocale = (locale: string): string | undefined => {
	const parts = locale.split(/_|-/);
	if (parts.length <= 1) return undefined;
	return parts[1];
};

const isRegionImperial = (region: string): boolean => {
	const imperialLocales = ['US', 'LR', 'MM']; // USA, Liberia, Myanmar
	return imperialLocales.includes(region.toUpperCase());
};
